export default "__VITE_ASSET__GCwWkVBV__"